// Mock data for SMG Media Group clone

export const navItems = [
  { label: 'WORK', href: '/#work' },
  { label: 'SPORTS MANAGEMENT', href: '/sports-management', route: true },
  { label: 'RALLI', href: '/ralli', route: true },
  { label: 'MATCHMAKER', href: '/matchmaker', route: true },
  { label: 'INSIGHTS', href: '/insights', route: true },
  { label: 'PLAYBOOKS', href: '/playbooks', route: true },
  { label: 'STUDIO', href: '/#studio' },
  { label: 'CONTACT', href: '/#contact' },
];

export const heroStats = [
  { value: 'AI · SI', label: 'NATIVE CREATIVE ENGINE' },
  { value: '320+', label: 'CREATOR & CELEBRITY NETWORK' },
  { value: '$340M', label: 'CO-BRAND REVENUE DRIVEN' },
  { value: '4.7x', label: 'AVG. ROAS ON CAMPAIGNS' },
];

export const capabilities = [
  {
    num: '01',
    title: 'AI & SI Creative',
    desc: 'Generative campaigns, synthetic personas, and AI-native content pipelines built in-house — not bolted on.',
    tags: ['GENERATIVE', 'SYNTHETIC TALENT', 'PIPELINES'],
    accent: '#FF3D2E',
    audio: '/assets/voice/01-ai-si.mp3',
    script: "AI and Synthetic Intelligence aren't tools we bolt on. They're our creative engine. We build generative campaigns, synthetic brand personas, and content pipelines that produce a year of work in a week. The next wave of branding isn't human versus machine. It's a director with infinite reach.",
  },
  {
    num: '02',
    title: 'Brand Identity',
    desc: 'Strategy, naming, visual systems and stories engineered to be recognized — and remembered.',
    tags: ['STRATEGY', 'NAMING', 'VISUAL IDENTITY'],
    accent: '#F3A83A',
    audio: '/assets/voice/02-brand-identity.mp3',
    script: "A brand isn't a logo. It's a worldview made visible. We engineer strategy, naming, and visual systems that don't just get recognized. They get repeated. In the AI era, the brands that win will be the ones humans want to defend.",
  },
  {
    num: '03',
    title: 'Co-Brand Engine',
    desc: 'We architect partnerships with creators, athletes and celebrity talent — from deal structure to drop execution.',
    tags: ['CREATORS', 'CELEBRITY', 'DROPS'],
    accent: '#D7FF3D',
    audio: '/assets/voice/03-co-brand.mp3',
    script: "The future isn't influencer marketing. It's co-owned IP. We architect partnerships between brands and creators, athletes, celebrities, and synthetic talent. Shared equity. Shared risk. Shared upside. One drop done right beats ten campaigns done loud.",
  },
  {
    num: '04',
    title: 'Film & Motion',
    desc: 'Cinematic content for brands that act like studios. Hero films, vertical cutdowns, AI-augmented post.',
    tags: ['DIRECTION', 'PRODUCTION', 'EDITORIAL'],
    accent: '#B04BFF',
    audio: '/assets/voice/04-film-motion.mp3',
    script: "Every brand now competes with studios. We direct cinematic films, vertical cutdowns, and AI-augmented post that turn product moments into culture. The future of brand storytelling is feature-quality on a startup budget.",
  },
  {
    num: '05',
    title: 'Growth, ROI & Analytics',
    desc: 'Paid, organic and earned — instrumented end-to-end. Live dashboards, attribution, incrementality testing.',
    tags: ['ATTRIBUTION', 'DASHBOARDS', 'PERFORMANCE'],
    accent: '#2DA6FF',
    audio: '/assets/voice/05-growth.mp3',
    script: "Creative without measurement is hope. We instrument every dollar. Paid, organic, earned. With live dashboards, attribution and incrementality testing. The future is brands that prove their lift in real time, not in a slide deck six months later.",
  },
];

export const coBrandTiers = [
  {
    range: '1M – 10M',
    title: 'Creator Class',
    desc: 'Vetted niche operators with conversion DNA. Always-on partnerships, not one-shots.',
    icon: 'users',
  },
  {
    range: '10M+',
    title: 'Celebrity Tier',
    desc: 'Marquee talent across sport, music and film. Equity-aligned drops & co-owned IP.',
    icon: 'sparkles',
  },
  {
    range: 'AI · SI',
    title: 'Synthetic Talent',
    desc: 'AI personas, virtual hosts and brand twins. 24/7 content velocity, zero scheduling.',
    icon: 'zap',
  },
];

export const engineSteps = [
  { num: '01', title: 'Match.', desc: 'Audience, voice, brand-safety screening' },
  { num: '02', title: 'Deal.', desc: 'Structure, equity, IP and rev-share modeling' },
  { num: '03', title: 'Make.', desc: 'Concept → shoot → post, with AI in the loop' },
  { num: '04', title: 'Measure.', desc: 'Lift studies, MMM, attribution to LTV' },
];

export const clients = [
  { num: '01', name: 'NIKE', tag: 'CO-BRAND · CULTURAL ACTIVATIONS', logoStyle: 'nike', url: 'https://www.nike.com', hoverBg: '#111111', motion: 'swoosh' },
  { num: '02', name: 'Mercedes-Benz', tag: 'BRAND · FILM', logoStyle: 'mercedes', url: 'https://www.mbusa.com/', hoverBg: '#00263A', motion: 'spin' },
  { num: '03', name: 'Tequila Comisario', tag: 'BRAND IDENTITY · DROPS', logoStyle: 'comisario', url: 'https://tequilacomisario.com/', hoverBg: '#8B5A2B', motion: 'pour' },
  { num: '04', name: 'JONES SODA CO.', tag: 'CO-BRAND · LIMITED EDITIONS', logoStyle: 'jones', url: 'https://www.mediapost.com/publications/article/365374/', hoverBg: '#E91E63', motion: 'bounce' },
  { num: '05', name: 'DELTA', tag: 'BRAND · CO-BRAND', logoStyle: 'delta', url: 'https://www.delta.com', hoverBg: '#0057B7', motion: 'takeoff' },
];

export const trustedBrandsMap = {
  comisario: { url: 'https://tequilacomisario.com/', label: 'Tequila Comisario' },
  jones: { url: 'https://www.mediapost.com/publications/article/365374/', label: 'Jones Soda Co.' },
  delta: { url: 'https://www.delta.com', label: 'Delta' },
  nike: { url: 'https://www.nike.com', label: 'Nike' },
  mercedes: { url: 'https://www.mbusa.com/', label: 'Mercedes-Benz' },
};

export const trustedBrands = ['comisario', 'jones', 'delta', 'nike', 'mercedes'];

export const studioInfo = {
  role: 'FOUNDER · CREATIVE DIRECTOR',
  name: 'Brian Stretch',
  title: 'MBA, ESQ.',
  quote: "Every brand we touch gets one operator who refuses to sleep until it's the answer in its category.",
  based: 'San Diego, CA · Nashville, TN',
  focus: 'AI · SI creative · Co-brand programs · Identity systems',
  tags: ['STRATEGY', 'AI · SI', 'CO-BRAND', 'DIRECTION', 'GROWTH'],
};

export const praise = {
  quote: "SMG didn't just rebrand us. They handed us a worldview. Eighteen months later we're a category leader — and culture finally caught up.",
  author: 'Noel Aguirre',
  role: 'LEE & ASSOCIATES · PRINCIPAL',
};

export const contactInfo = {
  email: 'info@smgmediagroup.com',
  studios: [
    { city: 'San Diego, CA', dept: 'Creative & Development Studio', phone: '+1 (619) 552-4677', address: '5840 El Camino, Suite 106, Carlsbad, CA 92008' },
    { city: 'Nashville, TN', dept: 'AI, SI, Coding & Development Studio', phone: '+1 (615) 619-3955', address: '1316 Adams Street, Germantown, Nashville, TN 37208', addressNote: 'By Appt Only' },
    { city: 'Carlsbad, CA', dept: 'SMG Sports Management Group International — Pickleball Division', phone: '+1 (619) 552-4677', address: '5840 El Camino, Suite 106, Carlsbad, CA 92008', addressNote: 'Direct line: repme@smgsportsmgt.com' },
  ],
  press: 'press@smgmediagroup.com',
};

export const budgetRanges = ['< $25K', '$25–75K', '$75–150K', '$150K+'];

export const services = [
  { title: 'Brand Development', desc: 'Positioning, identity systems, and voice engineered for premium markets.' },
  { title: 'Co-Branded Partnerships', desc: 'Talent, athlete, brand, and creator alliances built on shared IP and rev-share.' },
  { title: 'Social Media Strategy', desc: 'Owned-channel operating systems tuned to platform, audience, and conversion.' },
  { title: 'Paid Advertising', desc: 'Full-funnel media across Meta, Google, TikTok, YouTube, CTV, and premium digital.' },
  { title: 'Website & Funnel Development', desc: 'Site systems, landing pages, and DTC funnels wired to real business outcomes.' },
  { title: 'Content Production', desc: 'Editorial, cinematic film, short-form, and stills — built for a modern media stack.' },
  { title: 'Influencer & Athlete Campaigns', desc: 'Casting, deal structure, creative direction, and campaign execution end to end.' },
  { title: 'Experiential Marketing', desc: 'On-premise, hospitality, and cultural activations that turn products into moments.' },
  { title: 'AI & Strategic Intelligence', desc: 'Applied AI + SI across creative, planning, measurement, and audience modeling.' },
  { title: 'Revenue Strategy & Forecasting', desc: 'Media mix modeling, LTV/CAC discipline, and forecasting tied to the P&L.' },
];

export const industries = [
  'Sports',
  'Travel',
  'Lifestyle',
  'Medical',
  'Health & Wellness',
  'Consumer Products',
  'Hospitality',
  'Entertainment',
  'Membership Brands',
  'Athlete & Influencer',
];
